// Bilingual translations (Polish + English) with a runtime language switcher.
// `t` is a Proxy that always reads the current language dictionary, so existing
// `t.someKey` usages keep working. Components subscribe to language changes via
// the `useLanguage()` hook to trigger re-renders.

import { useEffect, useState } from "react";

const PL = {
  // Brand / Footer
  tagline: "Konkurencyjny dom Beyblade X. Turnieje, drabinki, rankingi i mistrzowskie talie.",
  footerCompete: "Rywalizuj",
  footerBuild: "Buduj",
  footerLegal: "Strona fanowska · Beyblade X jest znakiem towarowym TOMY",

  // Nav
  navHome: "Start",
  navTournaments: "Turnieje",
  navHost: "Zorganizuj",
  navDecks: "Talie",
  navPlayers: "Zawodnicy",
  navLeaderboard: "Ranking",
  navCreators: "Twórcy",
  regsLoadError: "Nie udało się załadować zapisanych talii — lista Beyów jest pusta.",
  retry: "Ponów",
  // Iter 32 — Deck of the Week
  dowEyebrow: "TALIA TYGODNIA",
  dowTitle: "Talia Tygodnia",
  dowSubtitle: "Wygrywa talia z największą liczbą głosów w poprzednim tygodniu. Głosuj na swojego faworyta — 1 głos na tydzień.",
  dowWinnerBadge: "ZWYCIĘZCA",
  dowNominees: "Nominacje bieżącego tygodnia",
  dowNoWinnerYet: "Brak zwycięzcy z poprzedniego tygodnia — bądź pierwszy, który zagłosuje w tym tygodniu.",
  dowNoNomineesYet: "Brak głosów w tym tygodniu.",
  dowBrowseDecks: "Przeglądaj talie",
  dowEmptyCta: "Nikt jeszcze nie zgłosił talii. Zbuduj pierwszą — może zostanie Talią Tygodnia i zdobędzie miejsce na stronie głównej.",
  dowEmptyBuildBtn: "Zbuduj talię",
  // Iter 41 — Emergent Google Sign-in
  signInWithGoogle: "Zaloguj przez Google",
  googleAuthTitle: "Kończenie logowania",
  googleAuthSuccess: "Zalogowano jako",
  googleAuthFailed: "Logowanie przez Google nie powiodło się",
  googleAuthMissing: "Brak identyfikatora sesji w linku zwrotnym",
  googleAuthHint: "Powered by Emergent — jedno kliknięcie, żadnego hasła do zapamiętania.",
  or: "lub",
  pleaseWait: "Chwilkę...",
  dowVotes: "głosów",
  dowVote: "Głosuj",
  dowVoted: "Zagłosowano",
  dowView: "Zobacz",
  dowLoadIntoBuilder: "Załaduj w Builderze",
  dowLoginToVote: "Zaloguj się, aby głosować",
  dowAlreadyVoted: "Już zagłosowałeś w tym tygodniu",
  dowVoteRecorded: "Głos zapisany!",
  beys: "Beyów",
  // Iter 32 — Match Timeline
  timelineTitle: "Oś czasu meczu",
  timelineTurns: "tur",
  timelineEmpty: "Brak zapisanych finiszy jeszcze",
  timelineRewindStart: "Cofnij do 0-0",
  timelineRewindTo: "Cofnij do tury {n}",
  navAdmin: "Admin",

  // Common
  loading: "Ładowanie...",
  back: "Powrót",
  cancel: "Anuluj",
  save: "Zapisz",
  edit: "Edytuj",
  delete: "Usuń",
  create: "Utwórz",
  update: "Zaktualizuj",
  search: "Szukaj...",
  required: "Wymagane",
  comingSoon: "Wkrótce",
  none: "Brak",
  ok: "OK",

  // Auth
  navLogin: "Zaloguj",
  navRegister: "Zarejestruj",
  navMyProfile: "Moje konto",
  navMyDecks: "Moje talie",
  registerTitle: "Załóż konto",
  registerSub: "Dołącz do społeczności BeyX i rywalizuj w turniejach.",
  loginTitle: "Witaj ponownie",
  loginSub: "Zaloguj się aby zarządzać swoimi taliami i turniejami.",
  registerCta: "Utwórz konto",
  haveAccount: "Masz już konto?",
  noAccount: "Nie masz konta?",
  toLogin: "Zaloguj się",
  toRegister: "Załóż konto",
  yourHandle: "Twój nick zawodnika",
  passwordMin: "Min. 6 znaków",
  joinTournament: "Dołącz do turnieju",
  leaveTournament: "Opuść turniej",
  alreadyJoined: "Zarejestrowany",
  selectDeck: "Wybierz talię",
  selectDeckSet: "Wybierz zestaw talii",
  noDecksYet: "Nie masz jeszcze talii. Utwórz pierwszą.",
  noDeckSetsYet: "Nie masz jeszcze zestawów talii.",
  createFirstDeck: "Utwórz pierwszą talię",
  registrationClosed: "Rejestracja zamknięta",
  tournamentFull: "Turniej pełny",
  joined: "Dołączono!",
  left: "Opuszczono",
  myProfileTitle: "Mój profil",
  myAccountTitle: "Moje konto",
  myDecksTitle: "Moje talie",
  myDeckSetsTitle: "Zestawy talii",
  myTournaments: "Moje turnieje",
  saveProfile: "Zapisz profil",
  profileUpdated: "Profil zaktualizowany",
  emailNotEditable: "E-maila nie można zmienić",
  logout: "Wyloguj",
  loginSuccess: "Zalogowano",
  registerSuccess: "Konto utworzone — witaj!",
  newDeckSet: "+ Nowy zestaw",
  editDeckSet: "Edytuj zestaw",
  deckSetName: "Nazwa zestawu",
  deckSetDescription: "Opis",
  deckSetDecks: "Talie w zestawie",
  selectDecks: "Wybierz talie z biblioteki",

  // Forgot / reset password
  forgotPassword: "Zapomniałem hasła",
  forgotTitle: "Reset hasła",
  forgotSub: "Wpisz adres e-mail — wyślemy link do zmiany hasła.",
  sendResetLink: "Wyślij link",
  sending: "Wysyłanie...",
  resetEmailSent: "Jeśli adres istnieje, wysłaliśmy link na e-mail.",
  resetTitle: "Ustaw nowe hasło",
  resetSub: "Wybierz nowe hasło dla swojego konta.",
  newPassword: "Nowe hasło",
  confirmPassword: "Potwierdź hasło",
  passwordsDontMatch: "Hasła nie pasują",
  resetCta: "Zmień hasło",
  resetSuccess: "Hasło zmienione — zaloguj się.",
  resetInvalidToken: "Link wygasł lub jest nieprawidłowy.",
  backToLogin: "Powrót do logowania",

  // Admin / users / formats
  badgeAdmin: "ADMIN",
  banned: "Zablokowany",
  tabUsers: "Użytkownicy",
  promote: "Awansuj na admina",
  demote: "Odbierz admina",
  ban: "Zablokuj",
  unban: "Odblokuj",
  promoted: "Nadano uprawnienia admina",
  demoted: "Odebrano uprawnienia admina",
  bannedToast: "Konto zablokowane",
  unbannedToast: "Konto odblokowane",
  formatDoubleElim: "Podwójna eliminacja",
  prizeBreakdown: "Nagrody (rozkład)",
  place: "Miejsce",
  prizeItem: "Nagroda",
  addPrizeRow: "+ Dodaj miejsce",
  bracketWinners: "Drabinka zwycięzców",
  bracketLosers: "Drabinka przegranych",
  bracketGrandFinal: "Finał generalny",
  bannedAccount: "Konto zablokowane",
  rootAdmin: "Główny admin",

  // Seeding / invites / subs
  shuffle: "Wymieszaj zawodników",
  shuffled: "Zawodnicy wymieszani",
  invite: "Zaproś",
  invited: "Wysłano zaproszenie",
  notifications: "Powiadomienia",
  noNotifications: "Brak powiadomień",
  tournamentInvite: "Zaproszenie do turnieju",
  accept: "Akceptuj",
  decline: "Odrzuć",
  pending: "Oczekujące",
  accepted: "Zaakceptowane",
  declined: "Odrzucone",
  inviteAccepted: "Zaakceptowano",
  inviteDeclined: "Odrzucono",
  substitutes: "Rezerwowi",
  addSub: "Dodaj rezerwowego",
  removeSub: "Usuń rezerwowego",
  swapPlayer: "Wymień zawodnika",
  swappedToast: "Wymieniono zawodnika",
  pickIncoming: "Wybierz zmiennika",
  noSubs: "Brak rezerwowych",
  inviteToTournament: "Zaproś do turnieju",

  // Approval / moderator
  approvalPending: "Oczekuje akceptacji",
  approvalRejected: "Odrzucony",
  approve: "Zatwierdź",
  reject: "Odrzuć",
  approvedToast: "Turniej zatwierdzony",
  rejectedToast: "Turniej odrzucony",
  pendingTournaments: "Turnieje do akceptacji",
  noPending: "Brak turniejów oczekujących na akceptację.",
  awaitingApproval: "Twój turniej oczekuje na akceptację admina.",
  moderator: "Moderator",
  moderators: "Moderatorzy",
  selected: "wybrano",
  generateBracket: "Generuj drabinkę",
  moderatorBadge: "MOD",
  noModerator: "Brak moderatora",
  chooseModerator: "Wybierz moderatora",
  setModerator: "Ustaw moderatora",
  clearModerator: "Wyczyść moderatora",
  moderatorSet: "Moderator zaktualizowany",
  moderatorHint:
    "Moderator może edytować mecze i zarządzać rezerwowymi / zaproszeniami.",

  // Referees / Scoring / Chat / Check-in / Tie-breaker (Iter10)
  referees: "Sędziowie",
  refereeBadge: "SĘD.",
  addReferee: "Dodaj sędziego",
  removeReferee: "Usuń sędziego",
  noReferees: "Brak sędziów",
  assignMatchReferee: "Przypisz sędziego",
  matchReferee: "Sędzia meczu",
  refereesUpdated: "Sędziowie zaktualizowani",
  scoringFormat: "Format punktacji",
  scoringFormatPB: "Standard",
  scoringFormatBP: "Beyblade Polska",
  scoreLimit: "Limit punktów",
  scoreLimitHint: "Wpisz dowolną liczbę punktów potrzebną do wygrania meczu.",
  knockoutScoreLimit: "Limit punktów w fazie pucharowej",
  knockoutScoreLimitHint: "Osobny próg wygranej w meczach fazy pucharowej. Pusto = dziedziczy limit z grup.",
  finishSpin: "Spin Finish",
  finishOver: "Over Finish",
  finishBurst: "Burst Finish",
  finishXtreme: "X-Treme Finish",
  finishOut: "Out Finish",
  finishTybuch: "Tybuch Finish",
  finishZetek: "Zetek Finish",
  refereePanel: "Panel sędziego",
  recordFinish: "Zapisz finish",
  undoLast: "Cofnij ostatni",
  scoreLabel: "Wynik",
  resetLast: "Reset",
  swapSides: "Zmiana stron",
  swapSidesHint: "Zamień pozycje graczy — ich wyniki podążają za nimi.",
  back: "Cofnij",
  next: "Dalej",
  chat: "Czat",
  chatEmpty: "Czat jest pusty. Bądź pierwszy!",
  chatPlaceholder: "Napisz wiadomość...",
  announcementPlaceholder: "Ogłoszenie do uczestników...",
  announcement: "Ogłoszenie",
  pin: "Przypnij",
  chatJoinToPost: "Dołącz do turnieju, aby pisać na czacie.",
  chatLoginToPost: "Zaloguj się, aby pisać na czacie.",
  checkInBtn: "Zamelduj się",
  checkedIn: "Zameldowany",
  checkedInToast: "Zameldowano!",
  checkInOpens: "Meldowanie za",
  checkInClosed: "Meldowanie zamknięte",
  checkInRequired: "Wymagane meldowanie",
  tieBreaker: "Dogrywka",
  tieBreakers: "Dogrywki",
  createTieBreaker: "Utwórz dogrywkę",
  detectTies: "Wykryj dogrywki",
  tieBreakersGenerated: "Utworzono dogrywki: ",
  noTies: "Brak remisów do rozstrzygnięcia",

  // Iter 11 — Settings / Maps / Pokeblade / Leaderboard inclusion
  tabSettings: "Ustawienia",
  tabCreators: "Twórcy",
  creatorsAdminHint: "Dodaj zdjęcia i krótkie bio osób stojących za BEYX.PL. Kolejność wyświetlania rośnie od najmniejszej wartości.",
  creatorsEyebrow: "TEAM",
  creatorsTitle: "Twórcy BEYX.PL",
  creatorsSubtitle: "Ludzie, którzy stoją za projektem — sędziowie, deweloperzy i sponsorzy społeczności.",
  noCreatorsYet: "Brak twórców. Dodaj pierwszego z panelu administratora.",
  newCreator: "Nowy twórca",
  editCreator: "Edytuj twórcę",
  creatorRole: "Rola / Tytuł",
  avatarUrl: "Zdjęcie (URL)",
  website: "Strona www",
  displayOrder: "Kolejność (mniejsze = wyżej)",
  nameRequired: "Nazwa jest wymagana",
  siteSettings: "Ustawienia strony",
  siteSettingsHint: "Linki społecznościowe, tło strony i tagline widoczne wszędzie.",
  discordUrl: "Link Discord",
  buymeacoffeeUrl: "Link wsparcia / Tipply",
  support: "Wesprzyj",
  sponsorUrl: "Link sponsora (URL)",
  sponsorName: "Nazwa sponsora (przycisk)",
  backgroundImageUrl: "URL tła strony",
  siteTagline: "Tagline strony",
  frontpageEditor: "Edytor strony głównej",
  frontpageEditorHint: "Pola puste = wartość domyślna z tłumaczenia. Nadpisz cokolwiek chcesz.",
  heroImageUrlLabel: "URL zdjęcia hero",
  heroEyebrowLabel: "Nagłówek hero (małe czerwone)",
  heroLine1Label: "Nagłówek hero — linia 1",
  heroLine2Label: "Nagłówek hero — linia 2 (kolor pink)",
  heroLine3Label: "Nagłówek hero — linia 3 (outline)",
  heroSubtitleLabel: "Podtytuł hero",
  heroCta1Label: "Przycisk 1 — etykieta",
  heroCta1Url: "Przycisk 1 — link",
  heroCta2Label: "Przycisk 2 — etykieta",
  heroCta2Url: "Przycisk 2 — link",
  saving: "Zapisywanie...",
  formatPokeblade: "Pokeblade (6 Beyów / talia)",
  pokebladeNote: "Pokeblade: 6 Beyów w jednej talii. Każdy gracz zaczyna z 6 życiami i traci 1 za każdą przegraną rundę. Kto pierwszy straci wszystkie 6 Beyów — przegrywa.",
  pokebladeLives: "Życia",
  pokebladeBeyLost: "Bey stracony (–1)",
  pokebladeEliminated: "WYELIMINOWANY",
  pokebladeLifeToast: "-1 ŻYCIE",
  // Iter 40 — uploader
  uploadImage: "Wgraj obraz",
  uploadHero: "Wgraj hero",
  uploadBackground: "Wgraj tło",
  uploadBanner: "Wgraj banner",
  uploading: "Wgrywanie...",
  uploaded: "Wgrano",
  uploadInvalidType: "Dozwolone formaty: PNG, JPG, WEBP, GIF",
  uploadTooLarge: "Obraz zbyt duży (max 6 MB)",
  // Iter 40 — BEY-PONG
  formatBeyPong: "BEY-PONG (4 Beye / talia · sety do 4+)",
  beyPongNote: "BEY-PONG: talia 4 Beyów (bez powtarzających się części, bez MN). Przed każdym meczem wybierz 3 z 4. Ustal ukrytą kolejność. Sety do 4+ punktów, BO3 w grupach/ćwierćfinałach, BO5 w półfinałach i finale.",
  beyPongDeckTitle: "Talia BEY-PONG (4 Beye)",
  beyPongDeckIntro: "Zarejestruj dokładnie 4 kompletne Beye. Żadna część nie może się powtarzać między Beyami. Części MN są zabronione.",
  beyPongSelectThree: "Wybierz 3 z 4",
  beyPongInactive: "NIEAKTYWNY",
  beyPongHiddenOrder: "Ukryta kolejność",
  beyPongLockOrder: "Zablokuj kolejność",
  beyPongOrderLocked: "Kolejność zablokowana",
  beyPongWaitingOpponent: "Oczekiwanie na przeciwnika...",
  beyPongRevealOrder: "Ujawnij kolejności",
  beyPongCurrentSet: "Set",
  beyPongCurrentCycle: "Cykl",
  beyPongCurrentRound: "Runda",
  beyPongSetWins: "Sety",
  beyPongTotalPoints: "Suma pkt",
  beyPongFinishSpin: "Spin (+1)",
  beyPongFinishOver: "Over (+2)",
  beyPongFinishBurst: "Burst (+2)",
  beyPongFinishTybuch: "Tybuch (+2)",
  beyPongFinishXtreme: "Extreme (+3)",
  beyPongFinishZetek: "Zetek (powtórka)",
  beyPongDraw: "Remis",
  beyPongLaunchError: "Błąd wystrzału",
  beyPongBurstPriority: "Priorytet Burst",
  beyPongSetEnd: "Koniec seta — zamień strony i ustal nową kolejność.",
  beyPongMatchEnd: "Mecz zakończony",
  beyPongTiebreakWarning: "Trzech lub więcej graczy jest zremisowanych — rozegraj tie-break ręcznie (jeden set do 4+ pkt).",
  beyPongStandings: "Klasyfikacja BEY-PONG",
  beyPongColMW: "Wygrane mecze",
  beyPongColSW: "Wygrane sety",
  beyPongColPts: "Punkty",
  beyPongGroupsHint: "Faza grupowa + BEY-PONG: gracze rywalizują w grupach BO3, awansują na podstawie zwycięstw meczy → setów → punktów. Standingi obliczane automatycznie.",
  beyPongNoDeck: "Nie zarejestrowałeś jeszcze talii BEY-PONG (4 Beye). Dołącz do turnieju z talią BEY-PONG, aby móc zablokować kolejność.",
  leaderboardIncluded: "Liczone do rankingu",
  leaderboardNotIncluded: "Nie liczone do rankingu",
  leaderboardOn: "Ranking",
  leaderboardOff: "Towarzyskie",
  leaderboardIncludedToast: "Włączono w ranking",
  leaderboardExcludedToast: "Wyłączono z rankingu",
  rankedBadge: "RANKING",
  openInMaps: "Otwórz w Mapach",
  getDirections: "Wyznacz trasę",

  // Iter 12 — Deck Builder (Iligan-style)
  deckBuilderTitle: "Kreator talii",
  deckBuilderIntro: "Złóż 3 Beye z pełnymi konfiguracjami. Wybierz Blade, Lockchip, Over Blade, Assist Blade, Ratchet i Bit dla każdego z nich.",
  deckBuilderIntroPokeblade: "Pokeblade: złóż 6 Beyów w jednej talii. Każdy z pełną konfiguracją (Blade, Lockchip, Over Blade, Assist Blade, Ratchet, Bit).",
  deckBuilderLoginGate: "Zaloguj się, aby tworzyć talie.",
  deckBuilderBtn: "Otwórz kreator",
  deckName: "Nazwa talii",
  deckNamePlaceholder: "Np. Mistrzowska Atak BO-3",
  deckDescriptionPlaceholder: "Strategia, typowe match-upy, kombinacje...",
  deckNameRequired: "Podaj nazwę talii",
  repeatingParts: "Powtarzające się części",
  repeatingPartsHint: "Pozwala używać tej samej części w wielu Beyach.",
  repeatingPartsViolation: "Wyłącz powtarzające się części lub usuń duplikaty.",
  refreshParts: "Odśwież części",
  clear: "Wyczyść",
  select: "Wybierz",
  duplicate: "Duplikat",
  noPartsYet: "Brak części tego typu — poproś admina o dodanie.",
  bulkAddComponents: "Wklej części (typ,nazwa na linię)",
  bulkAddBtn: "Importuj zbiorczo",
  bulkAddHint: "Format: typ,nazwa — jedna część na linię. Typy: blade, ratchet, bit, lockchip, assist_blade, overblade.",
  bulkAddPlaceholder: "blade,Dran Sword\nratchet,3-60\nbit,Point",
  bulkAdded: "Dodano: ",
  bulkSkipped: " · pominięte: ",

  // Iter 16 — BX/UX vs CX line locking
  mainBlade: "Main Blade",
  bxOrCx: "BX / CX",
  locked: "Zablokowane",
  lockedByBxUx: "Sloty CX są zablokowane, ponieważ wybrałeś Blade BX/UX (Expand). Wyczyść Blade, aby odblokować.",
  lockedByCx: "Slot Blade jest zablokowany, ponieważ używasz stosu CX (Lockchip + Main Blade + Assist Blade). Wyczyść je, aby odblokować.",

  // Iter 17 — Deck stats panel & radar
  deckStats: "Statystyki talii",
  deckStatsHint: "Sumaryczne wartości obliczone ze wszystkich Beyów.",
  statAttack: "Atak",
  statDefense: "Obrona",
  statStamina: "Wytrzymałość",
  statDash: "Przyspieszenie",
  statBurst: "Odporność na burst",
  statWeight: "Waga",
  statSpin: "Kierunek obrotu",
  statSeries: "Linia",
  deckAvg: "Średnia",
  deckTotal: "Suma",
  radarTitle: "Profil radarowy",
  partsSelected: "Wybrane części",
  emptyDeckHint: "Wybierz części, aby zobaczyć statystyki.",

  // Iter 18 — Undo/Redo + Random + Stat editor
  undo: "Cofnij",
  redo: "Przywróć",
  randomBey: "Losowy Bey",
  randomDeck: "Losowa talia",
  clearAll: "Wyczyść wszystko",
  editStats: "Edytuj statystyki",
  statValueHint: "Wartość 0–100",
  seriesLabel: "Linia (BX/UX/CX)",
  spinLabel: "Kierunek obrotu",
  spinRight: "Prawy",
  spinLeft: "Lewy",
  spinDual: "Dwukierunkowy",

  // Iter 19 — UX Infinity integrated ratchet
  integratedRatchetLabel: "Ostrze UX Infinity (zintegrowany ratchet)",
  integratedRatchetHint: "Zaznacz jeśli to ostrze zawiera wbudowany ratchet. Kreator talii automatycznie zablokuje slot Ratchet dla Beya, który używa tego ostrza.",
  uxInfinityLibraryLabel: "Ostrze UX Infinity (zintegrowany ratchet)",
  uxInfinityLibraryHint: "Zaznacz jeśli to ostrze jest częścią linii UX Infinity (zintegrowany ratchet). Gdy w Kreatorze talii Bey jest oznaczony jako UX Infinity, tylko takie ostrza będą dostępne w slocie Blade.",
  uxInfinityBadge: "UX Infinity",
  lockedByIntegratedRatchet: "Slot Ratchet jest zablokowany, ponieważ ten Bey jest oznaczony jako UX Infinity (zintegrowany ratchet).",
  lockedByUxInfinity: "Ten slot jest zablokowany, ponieważ Bey jest oznaczony jako UX Infinity. UX Infinity to jednoczęściowe ostrze BX/UX ze zintegrowanym ratchetem — nie może używać części CX (Lockchip, Overblade, Assist Blade) ani osobnego ratchetu.",
  integratedBadge: "Zintegrowany",
  mainBlade: "Main Blade",
  uxInfinity: "UX Infinity",
  uxInfinityHint: "Oznacz ten Bey jako UX Infinity (jednoczęściowe ostrze BX/UX ze zintegrowanym ratchetem). Sloty Ratchet, Lockchip, Overblade i Assist Blade zostaną zablokowane.",
  lockedByBxUxSeries: "Ten slot jest zablokowany, ponieważ w slocie Blade wybrano ostrze z serii BX/UX. Ostrza BX/UX są jednoczęściowe i nie używają części CX (Lockchip, Overblade, Assist Blade).",
  lockedByCxBlade: "Slot Overblade jest zablokowany, ponieważ w slocie Blade wybrano ostrze z serii CX. Główne ostrze CX pełni już rolę Overblade.",
  cxInfinityBadge: "CX Infinity",
  cxInfinityLibraryLabel: "Część CX Infinity (podkategoria)",
  cxInfinityLibraryHint: "Zaznacz jeśli ta część należy do linii CX Infinity. Główne ostrza CX Infinity mogą być używane razem z osobnym Overblade, więc slot Overblade nie zostaje automatycznie zablokowany.",
  roundTimer: "Timer rundy",
  resetLastToast: "RESET",
  swapSidesToast: "ZMIANA STRON",
  // Iter 43 — Referee quick gestures
  gestureHintUndo: "← Przesuń w lewo, aby cofnąć",
  gestureHintEnd: "Przytrzymaj środek 1s, aby zakończyć",
  gestureHintDismiss: "Rozumiem",
  gestureUndoToast: "COFNIĘTE",
  gestureEndToast: "MECZ ZAKOŃCZONY",
  gestureEndTied: "Wynik remisowy — najpierw przyznaj punkt",
  gestureEndDone: "Mecz już zakończony",
  gestureEndHold: "TRZYMAJ, ABY ZAKOŃCZYĆ…",
  exportJson: "Eksportuj JSON",
  importJson: "Importuj",
  exportHint: "Pobierz plik JSON i skopiuj do schowka do udostępnienia na Discordzie.",
  exportSuccess: "Talia wyeksportowana i skopiowana do schowka",
  importDeck: "Importuj talię z JSON",
  importHint: "Wklej pełny obiekt JSON z eksportu talii poniżej. Jeśli w Twojej bazie brakuje jakiejś części, jej slot zostanie pusty.",
  importErrorParse: "Nieprawidłowy JSON. Wklej całą treść eksportu.",
  importErrorSchema: "Nieznana wersja talii. Oczekiwano schematu 'beyx.deck.v1'.",
  importSuccess: "Talia zaimportowana. Sprawdź brakujące części i zapisz.",
  applyImport: "Zastosuj",

  // Statuses
  statusUpcoming: "Nadchodzący",
  statusLive: "Na żywo",
  statusCompleted: "Zakończony",
  filterAll: "Wszystkie",

  // Home
  heroEyebrow: "Sezon 03 · Cykl 2026 trwa",
  heroLine1: "KRĘĆ.",
  heroLine2: "UDERZAJ.",
  heroLine3: "DOMINUJ.",
  heroSubtitle:
    "Kreator talii i organizator turniejów — od Bladerów dla Bladerów!",
  heroBtnTournaments: "Zobacz turnieje",
  heroBtnDecks: "Przeglądaj talie",
  heroFeatured: "Wyróżnione ↳",
  heroPrize: "Pula",
  statActive: "Aktywne turnieje",
  statBladers: "Zarejestrowani zawodnicy",
  statDecks: "Mistrzowskie talie",
  statPrize: "Pula nagród (rok)",
  sectionCircuit: "Cykl",
  sectionTournaments: "Turnieje",
  sectionMeta: "Meta",
  sectionFeaturedDecks: "Wyróżnione talie",
  sectionRankings: "Ranking",
  sectionTopBladers: "Najlepsi zawodnicy",
  viewAll: "Zobacz wszystkie",

  // Tournaments
  tournamentsTitle: "Turnieje",
  noTournamentsCategory: "Brak turniejów w tej kategorii.",
  community: "Społeczność",
  format: "Format",
  formatSingleElim: "Pojedyncza eliminacja",
  formatGroupKnockout: "Faza grupowa + Pucharowa",
  bracket: "Drabinka",
  groups: "Grupy",
  bladers: "Zawodnicy",
  champion: "Mistrz",
  location: "Lokalizacja",
  start: "Start",
  prizePool: "Pula nagród",
  bracketEmpty: "Drabinka jeszcze nie została wygenerowana.",
  groupStandings: "Wyniki grupowe",
  group: "Grupa",
  knockout: "Pucharowa",

  // Players
  rosterTitle: "Zawodnicy",
  pts: "pkt",
  wins: "Wygrane",
  losses: "Porażki",
  winRate: "Procent zwycięstw",
  points: "Punkty",
  bladerProfile: "Profil zawodnika",
  decksUsed: "Używane talie",
  noDecksLinked: "Brak powiązanych talii.",
  rank: "Pozycja",
  blader: "Zawodnik",
  country: "Kraj",
  globalStandings: "Ranking globalny",
  leaderboardTitle: "Ranking",
  noStandings: "Brak rankingu.",

  // Decks
  decksTitle: "Biblioteka talii",
  arsenal: "Arsenał",
  archetype: "Archetyp",
  archAttack: "Atak",
  archDefense: "Obrona",
  archStamina: "Wytrzymałość",
  archBalanced: "Zbalansowana",
  componentLoadout: "Konfiguracja komponentów",
  bey: "Bey",
  blade: "Blade",
  ratchet: "Ratchet",
  bit: "Bit",
  lockchip: "Lockchip",
  assistBlade: "Assist Blade",
  overblade: "Overblade",
  tabBlades: "Blade'y",
  tabRatchets: "Ratchety",
  tabBits: "Bity",
  tabLockchips: "Lockchipy",
  tabAssistBlades: "Assist Blade'y",
  tabOverblades: "Overblade'y",

  // Host (community)
  hostEyebrow: "Tworzone przez zawodników",
  hostTitle: "Zorganizuj turniej",
  hostIntro:
    "Stwórz swój własny społecznościowy turniej Beyblade X — wybierz zawodników z listy, dodaj własne nicki, a my od razu wygenerujemy drabinkę.",
  hostFormDetails: "Szczegóły",
  hostFormRoster: "Lista zawodników",
  tournamentName: "Nazwa turnieju",
  hostHandle: "Twój nick (organizator)",
  description: "Opis",
  startDate: "Data startu",
  maxPlayers: "Maks. zawodników",
  bannerUrl: "URL banera (opcjonalnie)",
  addCustomBlader: "Dodaj własnego zawodnika",
  bladerName: "Nick zawodnika",
  pickFromRoster: "Wybierz z listy",
  rosterFull: "Lista pełna",
  alreadyAdded: "Już dodany",
  addAtLeastTwo: "Dodaj co najmniej 2 zawodników",
  bracketAutoNote: "Drabinka generuje się automatycznie po wysłaniu",
  launchTournament: "Uruchom turniej",
  creating: "Tworzenie...",
  created: "Turniej utworzony — drabinka gotowa!",
  failedToCreate: "Nie udało się utworzyć",
  tournamentNameSample: "Sobotnia Bitwa #4",
  hostHandleSample: "BurzowyZawodnik",
  locationSample: "Lokalna salka · Discord",
  prizePoolSample: "Honor · 100 zł",
  descriptionSample: "Format, zasady, klimat?",
  approvalNote:
    "Turniej będzie widoczny publicznie po zatwierdzeniu przez admina BEYX.PL.",

  // Admin login
  adminAccess: "Dostęp admina",
  controlRoom: "Centrum dowodzenia",
  email: "E-mail",
  password: "Hasło",
  signIn: "Zaloguj",
  authenticating: "Uwierzytelnianie...",
  defaultLogin: "Domyślnie: admin@beyx.gg / admin123",
  invalidCredentials: "Nieprawidłowe dane",

  // Admin dashboard
  adminDashboard: "Panel admina",
  controlRoomEyebrow: "Centrum dowodzenia",
  tabTournaments: "Turnieje",
  tabPlayers: "Zawodnicy",
  tabDecks: "Talie",
  tabComponents: "Części",
  tabApproval: "Akceptacja",

  newTournament: "+ Nowy turniej",
  editTournament: "Edytuj turniej",
  newPlayer: "+ Nowy zawodnik",
  reset: "Reset",
  resetStats: "Reset statystyk",
  resetAllStats: "Reset statystyk wszystkim",
  statsReset: "Statystyki zresetowane",
  statsResetAll: "Statystyki zresetowane (zawodników)",
  confirmResetStats: "Zresetować statystyki zawodnika {n}? Historia meczów pozostanie nietknięta.",
  confirmResetAllStats: "Zresetować wygrane / przegrane / punkty WSZYSTKIM zawodnikom? Historia meczów pozostanie nietknięta.",
  confirmResetAllStatsDoubleCheck: "Ostatnie potwierdzenie. Wszystkie liczniki na leaderboardzie wrócą do zera.",
  editPlayer: "Edytuj zawodnika",
  newDeck: "+ Nowa talia",
  editDeck: "Edytuj talię",
  newComponent: "+ Nowa część",
  editComponent: "Edytuj część",
  matches: "Mecze",
  bracketBtn: "Drabinka",
  generateKnockout: "Generuj fazę pucharową",
  saved: "Zapisano",
  deleted: "Usunięto",
  failed: "Nieudane",
  liveOn: "Na żywo",
  liveOff: "Offline",
  confirmDelete: "Usunąć?",
  purge: "Zniszcz",
  purgePlayerTitle: "Trwale usuń gracza + konto (e-mail, hasło, talie)",
  confirmPurgePlayer: "TRWALE usuń gracza „{n}\" wraz z kontem (e-mail, hasło, talie, rejestracje). Ta operacja jest NIEODWRACALNA. Kontynuować?",
  confirmPurgePlayerFinal: "Ostatnie potwierdzenie: wszystkie dane osobowe zostaną usunięte na zawsze. Kontynuować?",
  playerPurged: "Gracz zniszczony",
  matchResults: "Wyniki meczów",
  record: "Zapisz wynik",
  recordUpdate: "Zaktualizuj",

  // Tournament admin form
  slug: "Slug",
  endDate: "Data zakończenia",
  numGroups: "Liczba grup",
  advancersPerGroup: "Awansujący z grupy",
  status: "Status",
  players: "Zawodnicy",
  bracketCreated: "Drabinka utworzona",
  knockoutGenerated: "Faza pucharowa utworzona",

  // Components
  componentName: "Nazwa",
  componentType: "Typ",

  // Misc
  handle: "Nick",
  realName: "Imię i nazwisko",
  avatarUrl: "URL awatara",
  bio: "Bio",
  name: "Nazwa",
  ownedBy: "Pilotuje",
  hosted: "Społeczność",
  pts2: "pkt",
};

const EN = {
  // Brand / Footer
  tagline: "The competitive home of Beyblade X. Tournaments, brackets, rankings & meta decks.",
  footerCompete: "Compete",
  footerBuild: "Build",
  footerLegal: "Fan-made site · Beyblade X is a trademark of TOMY",

  // Nav
  navHome: "Home",
  navTournaments: "Tournaments",
  navHost: "Host",
  navDecks: "Decks",
  navPlayers: "Bladers",
  navLeaderboard: "Leaderboard",
  navCreators: "Creators",
  regsLoadError: "Failed to load registered decks — Active Bey list is empty.",
  retry: "Retry",
  // Iter 32 — Deck of the Week
  dowEyebrow: "DECK OF THE WEEK",
  dowTitle: "Deck of the Week",
  dowSubtitle: "The deck with the most fan votes last week wins. Cast your vote for a favorite — one vote per week.",
  dowWinnerBadge: "WINNER",
  dowNominees: "This week's nominees",
  dowNoWinnerYet: "No winner from last week yet — be the first to vote this week.",
  dowNoNomineesYet: "No votes yet this week.",
  dowBrowseDecks: "Browse decks",
  dowEmptyCta: "No decks submitted yet. Build the first one — it could be crowned Deck of the Week and take over the homepage.",
  dowEmptyBuildBtn: "Build a deck",
  // Iter 41 — Emergent Google Sign-in
  signInWithGoogle: "Sign in with Google",
  googleAuthTitle: "Finishing sign-in",
  googleAuthSuccess: "Signed in as",
  googleAuthFailed: "Google sign-in failed",
  googleAuthMissing: "Missing session_id in callback URL",
  googleAuthHint: "Powered by Emergent — one click, no password to remember.",
  or: "or",
  pleaseWait: "One moment...",
  dowVotes: "votes",
  dowVote: "Vote",
  dowVoted: "Voted",
  dowView: "View",
  dowLoadIntoBuilder: "Load in Builder",
  dowLoginToVote: "Sign in to vote",
  dowAlreadyVoted: "You already voted this week",
  dowVoteRecorded: "Vote recorded!",
  beys: "beys",
  // Iter 32 — Match Timeline
  timelineTitle: "Match timeline",
  timelineTurns: "turns",
  timelineEmpty: "No finishes recorded yet",
  timelineRewindStart: "Rewind to 0-0",
  timelineRewindTo: "Rewind to turn {n}",
  navAdmin: "Admin",

  // Common
  loading: "Loading...",
  back: "Back",
  cancel: "Cancel",
  save: "Save",
  edit: "Edit",
  delete: "Delete",
  create: "Create",
  update: "Update",
  search: "Search...",
  required: "Required",
  comingSoon: "Coming soon",
  none: "None",
  ok: "OK",

  // Auth
  navLogin: "Log in",
  navRegister: "Sign up",
  navMyProfile: "My account",
  navMyDecks: "My decks",
  registerTitle: "Create account",
  registerSub: "Join the BeyX community and battle in tournaments.",
  loginTitle: "Welcome back",
  loginSub: "Sign in to manage your decks and tournaments.",
  registerCta: "Create account",
  haveAccount: "Already have an account?",
  noAccount: "No account yet?",
  toLogin: "Sign in",
  toRegister: "Create account",
  yourHandle: "Your blader handle",
  passwordMin: "Min. 6 characters",
  joinTournament: "Join tournament",
  leaveTournament: "Leave tournament",
  alreadyJoined: "Registered",
  selectDeck: "Pick a deck",
  selectDeckSet: "Pick a deck set",
  noDecksYet: "You don't have any decks yet. Build your first one.",
  noDeckSetsYet: "No deck sets yet.",
  createFirstDeck: "Build my first deck",
  registrationClosed: "Registration closed",
  tournamentFull: "Tournament full",
  joined: "Joined!",
  left: "You left the tournament",
  myProfileTitle: "My profile",
  myAccountTitle: "My account",
  myDecksTitle: "My decks",
  myDeckSetsTitle: "Deck sets",
  myTournaments: "My tournaments",
  saveProfile: "Save profile",
  profileUpdated: "Profile updated",
  emailNotEditable: "Email can't be changed",
  logout: "Log out",
  loginSuccess: "Signed in",
  registerSuccess: "Account created — welcome!",
  newDeckSet: "+ New set",
  editDeckSet: "Edit set",
  deckSetName: "Set name",
  deckSetDescription: "Description",
  deckSetDecks: "Decks in this set",
  selectDecks: "Pick decks from your library",

  // Forgot / reset password
  forgotPassword: "Forgot password",
  forgotTitle: "Reset password",
  forgotSub: "Enter your email and we'll send you a reset link.",
  sendResetLink: "Send reset link",
  sending: "Sending...",
  resetEmailSent: "If that email exists, a reset link is on its way.",
  resetTitle: "Set a new password",
  resetSub: "Choose a new password for your account.",
  newPassword: "New password",
  confirmPassword: "Confirm password",
  passwordsDontMatch: "Passwords don't match",
  resetCta: "Change password",
  resetSuccess: "Password changed — sign in now.",
  resetInvalidToken: "Link expired or invalid.",
  backToLogin: "Back to sign in",

  // Admin / users / formats
  badgeAdmin: "ADMIN",
  banned: "Banned",
  tabUsers: "Users",
  promote: "Promote to admin",
  demote: "Revoke admin",
  ban: "Ban",
  unban: "Unban",
  promoted: "Admin granted",
  demoted: "Admin revoked",
  bannedToast: "Account banned",
  unbannedToast: "Account unbanned",
  formatDoubleElim: "Double elimination",
  prizeBreakdown: "Prize breakdown",
  place: "Place",
  prizeItem: "Prize",
  addPrizeRow: "+ Add place",
  bracketWinners: "Winners bracket",
  bracketLosers: "Losers bracket",
  bracketGrandFinal: "Grand final",
  bannedAccount: "Account banned",
  rootAdmin: "Root admin",

  // Seeding / invites / subs
  shuffle: "Shuffle seeds",
  shuffled: "Seeds shuffled",
  invite: "Invite",
  invited: "Invite sent",
  notifications: "Notifications",
  noNotifications: "No notifications",
  tournamentInvite: "Tournament invite",
  accept: "Accept",
  decline: "Decline",
  pending: "Pending",
  accepted: "Accepted",
  declined: "Declined",
  inviteAccepted: "Accepted",
  inviteDeclined: "Declined",
  substitutes: "Substitutes",
  addSub: "Add substitute",
  removeSub: "Remove substitute",
  swapPlayer: "Swap player",
  swappedToast: "Player swapped",
  pickIncoming: "Pick incoming player",
  noSubs: "No substitutes",
  inviteToTournament: "Invite to tournament",

  // Approval / moderator
  approvalPending: "Pending approval",
  approvalRejected: "Rejected",
  approve: "Approve",
  reject: "Reject",
  approvedToast: "Tournament approved",
  rejectedToast: "Tournament rejected",
  pendingTournaments: "Tournaments awaiting approval",
  noPending: "No tournaments awaiting approval.",
  awaitingApproval: "Your tournament is awaiting admin approval.",
  moderator: "Moderator",
  moderators: "Moderators",
  selected: "selected",
  generateBracket: "Generate bracket",
  moderatorBadge: "MOD",
  noModerator: "No moderator",
  chooseModerator: "Choose moderator",
  setModerator: "Set moderator",
  clearModerator: "Clear moderator",
  moderatorSet: "Moderator updated",
  moderatorHint:
    "Moderators can edit matches and manage substitutes / invites.",

  // Referees / Scoring / Chat / Check-in / Tie-breaker (Iter10)
  referees: "Referees",
  refereeBadge: "REF",
  addReferee: "Add referee",
  removeReferee: "Remove referee",
  noReferees: "No referees",
  assignMatchReferee: "Assign referee",
  matchReferee: "Match referee",
  refereesUpdated: "Referees updated",
  scoringFormat: "Scoring format",
  scoringFormatPB: "Standard",
  scoringFormatBP: "Beyblade Polska",
  scoreLimit: "Score limit",
  scoreLimitHint: "Type any number of points needed to win a match.",
  knockoutScoreLimit: "Knockout score limit",
  knockoutScoreLimitHint: "Separate win threshold used in the knockout stage. Leave blank to inherit the group limit.",
  finishSpin: "Spin Finish",
  finishOver: "Over Finish",
  finishBurst: "Burst Finish",
  finishXtreme: "X-Treme Finish",
  finishOut: "Out Finish",
  finishTybuch: "Tybuch Finish",
  finishZetek: "Zetek Finish",
  refereePanel: "Referee panel",
  recordFinish: "Record finish",
  undoLast: "Undo last",
  scoreLabel: "Score",
  resetLast: "Reset",
  swapSides: "Swap sides",
  swapSidesHint: "Swap the two players' positions — their scores follow them.",
  back: "Back",
  next: "Next",
  chat: "Chat",
  chatEmpty: "Chat is empty. Be the first!",
  chatPlaceholder: "Write a message...",
  announcementPlaceholder: "Announcement for participants...",
  announcement: "Announcement",
  pin: "Pin",
  chatJoinToPost: "Join the tournament to post in chat.",
  chatLoginToPost: "Sign in to post in chat.",
  checkInBtn: "Check in",
  checkedIn: "Checked in",
  checkedInToast: "You're checked in!",
  checkInOpens: "Check-in opens in",
  checkInClosed: "Check-in closed",
  checkInRequired: "Check-in required",
  tieBreaker: "Tie-breaker",
  tieBreakers: "Tie-breakers",
  createTieBreaker: "Create tie-breaker",
  detectTies: "Detect ties",
  tieBreakersGenerated: "Tie-breakers created: ",
  noTies: "No ties to resolve",

  // Iter 11 — Settings / Maps / Pokeblade / Leaderboard inclusion
  tabSettings: "Settings",
  tabCreators: "Creators",
  creatorsAdminHint: "Add photos and short bios of the people behind BEYX.PL. Lower display order shows higher on the public page.",
  creatorsEyebrow: "TEAM",
  creatorsTitle: "BEYX.PL Creators",
  creatorsSubtitle: "The humans behind the project — judges, developers and community sponsors.",
  noCreatorsYet: "No creators yet. Add the first one from the admin panel.",
  newCreator: "New Creator",
  editCreator: "Edit Creator",
  creatorRole: "Role / Title",
  avatarUrl: "Avatar (URL)",
  website: "Website",
  displayOrder: "Display order (lower = higher)",
  nameRequired: "Name is required",
  siteSettings: "Site settings",
  siteSettingsHint: "Social links, page background and tagline shown across the site.",
  discordUrl: "Discord invite URL",
  buymeacoffeeUrl: "Buy Me a Coffee URL",
  support: "Wesprzyj",
  sponsorUrl: "Sponsor URL",
  sponsorName: "Sponsor button label",
  backgroundImageUrl: "Background image URL",
  siteTagline: "Site tagline",
  frontpageEditor: "Frontpage editor",
  frontpageEditorHint: "Empty fields fall back to the localized default. Override anything you like.",
  heroImageUrlLabel: "Hero image URL",
  heroEyebrowLabel: "Hero eyebrow (small red)",
  heroLine1Label: "Hero headline — line 1",
  heroLine2Label: "Hero headline — line 2 (pink color)",
  heroLine3Label: "Hero headline — line 3 (outline)",
  heroSubtitleLabel: "Hero subtitle",
  heroCta1Label: "Primary CTA — label",
  heroCta1Url: "Primary CTA — link",
  heroCta2Label: "Secondary CTA — label",
  heroCta2Url: "Secondary CTA — link",
  saving: "Saving...",
  formatPokeblade: "Pokeblade (6 Beys / deck)",
  pokebladeNote: "Pokeblade: 6 Beys in one deck. Each player starts with 6 lives and loses 1 per lost round. First to lose all 6 Beys loses the match.",
  pokebladeLives: "Lives",
  pokebladeBeyLost: "Bey Lost (–1)",
  pokebladeEliminated: "ELIMINATED",
  pokebladeLifeToast: "-1 LIFE",
  // Iter 40 — uploader
  uploadImage: "Upload image",
  uploadHero: "Upload hero image",
  uploadBackground: "Upload background",
  uploadBanner: "Upload banner",
  uploading: "Uploading...",
  uploaded: "Uploaded",
  uploadInvalidType: "Only PNG, JPG, WEBP, GIF are allowed",
  uploadTooLarge: "Image too large (max 6 MB)",
  // Iter 40 — BEY-PONG
  formatBeyPong: "BEY-PONG (4 Beys / deck · sets to 4+)",
  beyPongNote: "BEY-PONG: register 4 Beys (no duplicate parts, no MN parts). Before each match pick 3 of 4. Set a hidden order. Sets go to 4+ points. BO3 in groups/quarterfinals, BO5 in semifinals and final.",
  beyPongDeckTitle: "BEY-PONG deck (4 Beys)",
  beyPongDeckIntro: "Register exactly 4 complete Beys. No part may be duplicated between them. MN parts are prohibited.",
  beyPongSelectThree: "Pick 3 of 4",
  beyPongInactive: "INACTIVE",
  beyPongHiddenOrder: "Hidden order",
  beyPongLockOrder: "Lock order",
  beyPongOrderLocked: "Order locked",
  beyPongWaitingOpponent: "Waiting for opponent...",
  beyPongRevealOrder: "Reveal orders",
  beyPongCurrentSet: "Set",
  beyPongCurrentCycle: "Cycle",
  beyPongCurrentRound: "Round",
  beyPongSetWins: "Sets",
  beyPongTotalPoints: "Total pts",
  beyPongFinishSpin: "Spin (+1)",
  beyPongFinishOver: "Over (+2)",
  beyPongFinishBurst: "Burst (+2)",
  beyPongFinishTybuch: "Tybuch (+2)",
  beyPongFinishXtreme: "Extreme (+3)",
  beyPongFinishZetek: "Zetek (replay)",
  beyPongDraw: "Draw",
  beyPongLaunchError: "Launch error",
  beyPongBurstPriority: "Burst priority",
  beyPongSetEnd: "Set ended — switch sides and set a new order.",
  beyPongMatchEnd: "Match complete",
  beyPongTiebreakWarning: "Three or more players are tied — run the tiebreaker manually (one set to 4+ points).",
  beyPongStandings: "BEY-PONG standings",
  beyPongColMW: "Match wins",
  beyPongColSW: "Set wins",
  beyPongColPts: "Points scored",
  beyPongGroupsHint: "Group stage + BEY-PONG: players compete in BO3 groups; advancement is match wins → set wins → total points scored. Standings compute automatically.",
  beyPongNoDeck: "You have not registered a 4-Bey BEY-PONG deck yet. Join the tournament with a BEY-PONG deck (4 Beys) to lock in.",
  leaderboardIncluded: "Counts toward leaderboard",
  leaderboardNotIncluded: "Not counted toward leaderboard",
  leaderboardOn: "Ranked",
  leaderboardOff: "Unranked",
  leaderboardIncludedToast: "Tournament added to leaderboard",
  leaderboardExcludedToast: "Tournament removed from leaderboard",
  rankedBadge: "RANKED",
  openInMaps: "Open in Maps",
  getDirections: "Get directions",

  // Iter 12 — Deck Builder (Iligan-style)
  deckBuilderTitle: "Deck Builder",
  deckBuilderIntro: "Build 3 Beys with full part loadouts. Pick a Blade, Lockchip, Over Blade, Assist Blade, Ratchet and Bit for each.",
  deckBuilderIntroPokeblade: "Pokeblade: build 6 Beys in a single deck. Each with a full loadout (Blade, Lockchip, Over Blade, Assist Blade, Ratchet, Bit).",
  deckBuilderLoginGate: "Sign in to start building decks.",
  deckBuilderBtn: "Open builder",
  deckName: "Deck name",
  deckNamePlaceholder: "e.g. Tournament Attack BO-3",
  deckDescriptionPlaceholder: "Strategy, match-ups, combos...",
  deckNameRequired: "Enter a deck name",
  repeatingParts: "Repeating parts",
  repeatingPartsHint: "Allow using the same part in multiple Beys.",
  repeatingPartsViolation: "Enable repeating parts or remove duplicates.",
  refreshParts: "Refresh parts",
  clear: "Clear",
  select: "Select",
  duplicate: "Duplicate",
  noPartsYet: "No parts of this type yet — ask an admin to add some.",
  bulkAddComponents: "Paste parts (type,name per line)",
  bulkAddBtn: "Bulk import",
  bulkAddHint: "Format: type,name — one per line. Types: blade, ratchet, bit, lockchip, assist_blade, overblade.",
  bulkAddPlaceholder: "blade,Dran Sword\nratchet,3-60\nbit,Point",
  bulkAdded: "Added: ",
  bulkSkipped: " · skipped: ",

  // Iter 16 — BX/UX vs CX line locking
  mainBlade: "Main Blade",
  bxOrCx: "BX / CX",
  locked: "Locked",
  lockedByBxUx: "CX stack slots are locked because you picked a BX/UX (Expand) Blade. Clear the Blade slot to unlock.",
  lockedByCx: "Blade slot is locked because you're using a CX stack (Lockchip + Main Blade + Assist Blade). Clear them to unlock.",

  // Iter 17 — Deck stats panel & radar
  deckStats: "Deck stats",
  deckStatsHint: "Aggregate values computed across all Beys.",
  statAttack: "Attack",
  statDefense: "Defense",
  statStamina: "Stamina",
  statDash: "Dash",
  statBurst: "Burst resistance",
  statWeight: "Weight",
  statSpin: "Spin direction",
  statSeries: "Series",
  deckAvg: "Average",
  deckTotal: "Total",
  radarTitle: "Radar profile",
  partsSelected: "Parts selected",
  emptyDeckHint: "Pick some parts to see stats.",

  // Iter 18 — Undo/Redo + Random + Stat editor
  undo: "Undo",
  redo: "Redo",
  randomBey: "Random Bey",
  randomDeck: "Random deck",
  clearAll: "Clear all",
  editStats: "Edit stats",
  statValueHint: "Value 0–100",
  seriesLabel: "Series (BX/UX/CX)",
  spinLabel: "Spin direction",
  spinRight: "Right",
  spinLeft: "Left",
  spinDual: "Dual",

  // Iter 19 — UX Infinity integrated ratchet
  integratedRatchetLabel: "UX Infinity blade (integrated ratchet)",
  integratedRatchetHint: "Tick if this blade ships with a built-in ratchet. The Deck Builder will automatically lock the Ratchet slot for any Bey that uses this blade.",
  lockedByIntegratedRatchet: "Ratchet slot is locked because this Bey is marked as UX Infinity (integrated ratchet).",
  lockedByUxInfinity: "This slot is locked because the Bey is marked as UX Infinity. UX Infinity is a one-piece BX/UX blade with an integrated ratchet — it can't use CX parts (Lockchip, Over Blade, Assist Blade) or a separate ratchet.",
  integratedBadge: "Integrated",
  mainBlade: "Main Blade",
  uxInfinity: "UX Infinity",
  uxInfinityHint: "Mark this Bey as UX Infinity (one-piece BX/UX blade with an integrated ratchet). The Ratchet, Lockchip, Over Blade and Assist Blade slots will be locked.",
  lockedByBxUxSeries: "This slot is locked because the Blade slot holds a BX/UX-series part. BX/UX blades are one-piece and don't use CX parts (Lockchip, Over Blade, Assist Blade).",
  lockedByCxBlade: "The Over Blade slot is locked because the Blade slot holds a CX-series part. A CX main blade already fills the Over Blade role.",
  cxInfinityBadge: "CX Infinity",
  cxInfinityLibraryLabel: "CX Infinity part (sub-category)",
  cxInfinityLibraryHint: "Tick this if the part belongs to the CX Infinity line. CX Infinity main blades can be paired with a separate Over Blade, so the Over Blade slot is NOT auto-locked when a CX Infinity blade is selected.",
  roundTimer: "Round timer",
  resetLastToast: "RESET",
  swapSidesToast: "SIDES SWAPPED",
  // Iter 43 — Referee quick gestures
  gestureHintUndo: "← Swipe left to undo",
  gestureHintEnd: "Hold center 1s to end match",
  gestureHintDismiss: "Got it",
  gestureUndoToast: "UNDONE",
  gestureEndToast: "MATCH ENDED",
  gestureEndTied: "Score tied — award a point first",
  gestureEndDone: "Match already completed",
  gestureEndHold: "HOLD TO END…",
  // Iter 23 EN library keys (fill missing translations flagged by testing agent)
  uxInfinityLibraryLabel: "UX Infinity blade (integrated ratchet)",
  uxInfinityLibraryHint: "Tick this if the blade belongs to the UX Infinity line (integrated ratchet). When a Bey is marked UX Infinity in the Deck Builder, only these blades will be selectable in the Blade slot.",
  uxInfinityBadge: "UX Infinity",
  // Iter 22 — Deck sharing
  exportJson: "Export JSON",
  importJson: "Import",
  exportHint: "Downloads a JSON file and copies it to the clipboard for Discord sharing.",
  exportSuccess: "Deck exported and copied to clipboard",
  importDeck: "Import deck from JSON",
  importHint: "Paste the full JSON payload from a deck export below. Any part missing from your database will leave its slot empty.",
  importErrorParse: "Invalid JSON. Paste the entire export blob.",
  importErrorSchema: "Unknown deck version. Expected schema 'beyx.deck.v1'.",
  importSuccess: "Deck imported. Review any missing parts and save.",
  applyImport: "Apply",

  // Statuses
  statusUpcoming: "Upcoming",
  statusLive: "Live",
  statusCompleted: "Completed",
  filterAll: "All",

  // Home
  heroEyebrow: "Season 03 · 2026 Circuit in progress",
  heroLine1: "SPIN.",
  heroLine2: "STRIKE.",
  heroLine3: "DOMINATE.",
  heroSubtitle:
    "Deck Builder and Tournament Creator by Bladers for Bladers!",
  heroBtnTournaments: "See tournaments",
  heroBtnDecks: "Browse decks",
  heroFeatured: "Featured ↳",
  heroPrize: "Prize",
  statActive: "Active tournaments",
  statBladers: "Registered bladers",
  statDecks: "Meta decks",
  statPrize: "Prize pool (year)",
  sectionCircuit: "Circuit",
  sectionTournaments: "Tournaments",
  sectionMeta: "Meta",
  sectionFeaturedDecks: "Featured decks",
  sectionRankings: "Rankings",
  sectionTopBladers: "Top bladers",
  viewAll: "View all",

  // Tournaments
  tournamentsTitle: "Tournaments",
  noTournamentsCategory: "No tournaments in this category.",
  community: "Community",
  format: "Format",
  formatSingleElim: "Single elimination",
  formatGroupKnockout: "Group + Knockout",
  bracket: "Bracket",
  groups: "Groups",
  bladers: "Bladers",
  champion: "Champion",
  location: "Location",
  start: "Start",
  prizePool: "Prize pool",
  bracketEmpty: "Bracket hasn't been generated yet.",
  groupStandings: "Group standings",
  group: "Group",
  knockout: "Knockout",

  // Players
  rosterTitle: "Bladers",
  pts: "pts",
  wins: "Wins",
  losses: "Losses",
  winRate: "Win rate",
  points: "Points",
  bladerProfile: "Blader profile",
  decksUsed: "Decks used",
  noDecksLinked: "No decks linked.",
  rank: "Rank",
  blader: "Blader",
  country: "Country",
  globalStandings: "Global standings",
  leaderboardTitle: "Leaderboard",
  noStandings: "No standings.",

  // Decks
  decksTitle: "Deck library",
  arsenal: "Arsenal",
  archetype: "Archetype",
  archAttack: "Attack",
  archDefense: "Defense",
  archStamina: "Stamina",
  archBalanced: "Balanced",
  componentLoadout: "Component loadout",
  bey: "Bey",
  blade: "Blade",
  ratchet: "Ratchet",
  bit: "Bit",
  lockchip: "Lockchip",
  assistBlade: "Assist Blade",
  overblade: "Overblade",
  tabBlades: "Blades",
  tabRatchets: "Ratchets",
  tabBits: "Bits",
  tabLockchips: "Lockchips",
  tabAssistBlades: "Assist Blades",
  tabOverblades: "Overblades",

  // Host (community)
  hostEyebrow: "Player-hosted",
  hostTitle: "Host a tournament",
  hostIntro:
    "Create your own community Beyblade X tournament — pick bladers from the roster, add custom handles, and we'll auto-generate the bracket.",
  hostFormDetails: "Details",
  hostFormRoster: "Roster",
  tournamentName: "Tournament name",
  hostHandle: "Your handle (organizer)",
  description: "Description",
  startDate: "Start date",
  maxPlayers: "Max players",
  bannerUrl: "Banner URL (optional)",
  addCustomBlader: "Add custom blader",
  bladerName: "Blader handle",
  pickFromRoster: "Pick from roster",
  rosterFull: "Roster full",
  alreadyAdded: "Already added",
  addAtLeastTwo: "Add at least 2 bladers",
  bracketAutoNote: "Bracket is generated automatically on submit",
  launchTournament: "Launch tournament",
  creating: "Creating...",
  created: "Tournament created — bracket ready!",
  failedToCreate: "Failed to create",
  tournamentNameSample: "Saturday Showdown #4",
  hostHandleSample: "StormBlader",
  locationSample: "Local hall · Discord",
  prizePoolSample: "Honor · $25",
  descriptionSample: "Format, rules, vibes?",
  approvalNote:
    "Tournament will be public after a BEYX.PL admin approves it.",

  // Admin login
  adminAccess: "Admin access",
  controlRoom: "Control room",
  email: "Email",
  password: "Password",
  signIn: "Sign in",
  authenticating: "Authenticating...",
  defaultLogin: "Default: admin@beyx.gg / admin123",
  invalidCredentials: "Invalid credentials",

  // Admin dashboard
  adminDashboard: "Admin dashboard",
  controlRoomEyebrow: "Control room",
  tabTournaments: "Tournaments",
  tabPlayers: "Bladers",
  tabDecks: "Decks",
  tabComponents: "Parts",
  tabApproval: "Approval",

  newTournament: "+ New tournament",
  editTournament: "Edit tournament",
  newPlayer: "+ New blader",
  reset: "Reset",
  resetStats: "Reset stats",
  resetAllStats: "Reset all stats",
  statsReset: "Stats reset",
  statsResetAll: "Stats reset (players)",
  confirmResetStats: "Reset {n}'s wins/losses/points? Match history stays intact.",
  confirmResetAllStats: "Reset wins / losses / points for EVERY player? Match history stays intact.",
  confirmResetAllStatsDoubleCheck: "Final confirmation. Every leaderboard counter will go back to zero.",
  editPlayer: "Edit blader",
  newDeck: "+ New deck",
  editDeck: "Edit deck",
  newComponent: "+ New part",
  editComponent: "Edit part",
  matches: "Matches",
  bracketBtn: "Bracket",
  generateKnockout: "Generate knockout stage",
  saved: "Saved",
  deleted: "Deleted",
  failed: "Failed",
  liveOn: "Live",
  liveOff: "Offline",
  confirmDelete: "Delete?",
  purge: "Purge",
  purgePlayerTitle: "Permanently delete player + account (email, password, decks)",
  confirmPurgePlayer: "PERMANENTLY delete player \"{n}\" together with their account (email, password, decks, registrations). This action is IRREVERSIBLE. Continue?",
  confirmPurgePlayerFinal: "Final confirmation: all personal data will be erased forever. Continue?",
  playerPurged: "Player purged",
  matchResults: "Match results",
  record: "Save result",
  recordUpdate: "Update",

  // Tournament admin form
  slug: "Slug",
  endDate: "End date",
  numGroups: "Number of groups",
  advancersPerGroup: "Advancing per group",
  status: "Status",
  players: "Bladers",
  bracketCreated: "Bracket created",
  knockoutGenerated: "Knockout stage created",

  // Components
  componentName: "Name",
  componentType: "Type",

  // Misc
  handle: "Handle",
  realName: "Real name",
  avatarUrl: "Avatar URL",
  bio: "Bio",
  name: "Name",
  ownedBy: "Piloted by",
  hosted: "Community",
  pts2: "pts",
};

const DICTS = { pl: PL, en: EN };
const STORAGE_KEY = "beyx-lang";

function readInitialLang() {
  if (typeof window === "undefined") return "pl";
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    if (v && DICTS[v]) return v;
  } catch (e) { /* noop */ }
  return "pl";
}

let currentLang = readInitialLang();
const listeners = new Set();

export const t = new Proxy({}, {
  get(_target, key) {
    if (typeof key !== "string") return undefined;
    const dict = DICTS[currentLang] || PL;
    if (key in dict) return dict[key];
    if (key in PL) return PL[key];
    return key;
  },
});

export function getLanguage() {
  return currentLang;
}

export function setLanguage(lang) {
  if (!DICTS[lang] || lang === currentLang) return;
  currentLang = lang;
  try {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, lang);
      window.document.documentElement.lang = lang;
    }
  } catch (e) { /* noop */ }
  listeners.forEach((fn) => {
    try { fn(lang); } catch (e) { /* noop */ }
  });
}

export function toggleLanguage() {
  setLanguage(currentLang === "pl" ? "en" : "pl");
}

export function useLanguage() {
  const [lang, setLang] = useState(currentLang);
  useEffect(() => {
    const fn = (next) => setLang(next);
    listeners.add(fn);
    return () => { listeners.delete(fn); };
  }, []);
  return [lang, setLanguage];
}

export function statusLabel(s) {
  if (s === "upcoming") return t.statusUpcoming;
  if (s === "live") return t.statusLive;
  if (s === "completed") return t.statusCompleted;
  return s;
}

export function archetypeLabel(a) {
  const map = {
    Attack: t.archAttack,
    Defense: t.archDefense,
    Stamina: t.archStamina,
    Balanced: t.archBalanced,
  };
  return map[a] || a;
}

export function componentTypeLabel(type) {
  const map = {
    blade: t.blade,
    ratchet: t.ratchet,
    bit: t.bit,
    lockchip: t.lockchip,
    assist_blade: t.assistBlade,
    overblade: t.overblade,
    main_blade: t.mainBlade,
  };
  return map[type] || type;
}
